<template>
	<div>
		<el-cascader :value="value" :options="options" :size="size" :placeholder="placeholder" :disabled="disabled"
			filterable clearable @change="change"></el-cascader>
		<!-- 		<template v-if="el">
			<el-cascader :value="value" :options="options" :size="size" :placeholder="placeholder" :disabled="disabled"
				filterable clearable @change="change"></el-cascader>
		</template>
		<template v-else>
			<div>未知</div>
		</template> -->
	</div>
</template>

<script>
	import selectBase from '@_system/components/base/select.js'
	import province_city_area from "@form-create/data/dist/province_city_area.js"
	export default {
		mixins: [selectBase],
		props: {

		},
		data() {
			return {
				ready: false,
				options: [],
			}
		},
		created() {

		},
		watch: {
			value(e) {
				this.change(e)
			}
		},
		computed: {

		},

		methods: {
			list() {
				this.options = province_city_area
				this.finish()
			}
		}
	}
</script>
